export { LOGISTICS_COMPANIES } from "./logisticsCarrierRules";

export function normalizeStringList(value) {
  if (!value) return [];
  if (Array.isArray(value)) {
    return [...new Set(value.map(item => String(item || "").trim()).filter(Boolean))];
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? normalizeStringList(parsed) : normalizeStringList(trimmed);
      } catch (e) {
        // fall through
      }
    }
    return [
      ...new Set(
        trimmed
          .split(/[,，;；\s]+/)
          .map(item => item.trim())
          .filter(Boolean)
      ),
    ];
  }
  return [];
}

export function calcLineAmount(unitPrice, quantity) {
  const price = parseFloat(unitPrice) || 0;
  const qty = parseInt(quantity, 10) || 0;
  return parseFloat((price * qty).toFixed(2));
}

export function createEmptyProductLine() {
  return {
    productType: "",
    productName: "",
    unitPrice: "",
    quantity: "",
    lineAmount: 0,
  };
}

export function normalizeProductLine(raw, productList) {
  const line = raw || {};
  const productType = line.productType === undefined || line.productType === null ? "" : line.productType;
  let productName = String(line.productName || "").trim();
  if (!productName && productType !== "" && productList) {
    const matched = productList.find(item => String(item.productType) === String(productType));
    productName = matched ? matched.productName || "" : "";
  }
  const unitPrice = line.unitPrice === "" || line.unitPrice === null || line.unitPrice === undefined ? "" : line.unitPrice;
  const quantity = line.quantity === "" || line.quantity === null || line.quantity === undefined ? "" : line.quantity;
  return {
    productType,
    productName,
    unitPrice,
    quantity,
    lineAmount: calcLineAmount(unitPrice, quantity),
  };
}

export function normalizeProductLines(value, productList) {
  let list = value;
  if (typeof value === "string" && value.trim()) {
    try {
      list = JSON.parse(value);
    } catch (e) {
      list = [];
    }
  }
  if (!Array.isArray(list)) return [];
  return list.map(item => normalizeProductLine(item, productList)).filter(item => item.productType !== "" || item.productName);
}

export function normalizeProductLinesFromRow(row, productList) {
  if (!row) return [];
  if (row.productLines && row.productLines.length) {
    return normalizeProductLines(row.productLines, productList);
  }
  if (row.productType !== undefined && row.productType !== null && row.productType !== "") {
    return [
      normalizeProductLine(
        {
          productType: row.productType,
          productName: row.productName || "",
          unitPrice: row.unitPrice,
          quantity: row.quantity,
        },
        productList
      ),
    ];
  }
  return [];
}

export function formatProductNameSummary(lines) {
  const list = (lines || []).filter(item => item && item.productName);
  if (!list.length) return "";
  if (list.length === 1) return list[0].productName;
  return `${list[0].productName} 等${list.length}项`;
}

export function validateProductLines(lines) {
  const list = lines || [];
  if (!list.length) return "请至少添加一个产品";
  for (let i = 0; i < list.length; i++) {
    const line = list[i];
    if (line.productType === "" || line.productType === null || line.productType === undefined) {
      return `第 ${i + 1} 行请选择产品类型`;
    }
    if (!String(line.productName || "").trim()) {
      return `第 ${i + 1} 行产品名称不能为空`;
    }
    const qty = parseInt(line.quantity, 10);
    if (!qty || qty <= 0) {
      return `第 ${i + 1} 行采购数量须大于 0`;
    }
  }
  return "";
}

export function serializeProductLinesForSubmit(lines) {
  return JSON.stringify(
    (lines || []).map(line => ({
      productType: line.productType,
      productName: String(line.productName || "").trim(),
      unitPrice: parseFloat(line.unitPrice) || 0,
      quantity: parseInt(line.quantity, 10) || 0,
      lineAmount: calcLineAmount(line.unitPrice, line.quantity),
    }))
  );
}

export function createEmptyLogisticsForm() {
  return {
    _id: "",
    orderNo: "",
    date: "",
    shopName: "",
    supplierId: "",
    supplierName: "",
    actualPaidAmount: "",
    purchaseOrderId: "",
    source: "manual",
    productLines: [createEmptyProductLine()],
    logisticsCompany: "",
    logisticsNos: [],
    boxCount: null,
    waybillNos: [],
    supplierWaybillPhotos: [],
    receiveLogisticsImages: [],
    remark: "",
  };
}
